import { render, staticRenderFns } from "./vindi.vue?vue&type=template&id=17fa255b&"
import script from "./vindi.vue?vue&type=script&lang=js&"
export * from "./vindi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17fa255b')) {
      api.createRecord('17fa255b', component.options)
    } else {
      api.reload('17fa255b', component.options)
    }
    module.hot.accept("./vindi.vue?vue&type=template&id=17fa255b&", function () {
      api.rerender('17fa255b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/order/vindi/vindi.vue"
export default component.exports